// ODR: hovering a color swatch on the product page previews that color in the main media carousel.
// Leaving the swatch row returns to the selected color. Clicking still selects the color as normal.
(() => {
  if (window.odrSwatchHover) return;
  window.odrSwatchHover = true;

  const SWATCH_ROW = 'variant-picker .variant-option--swatches';

  /** @param {HTMLInputElement | null} input */
  const showMedia = (input) => {
    const id = input?.dataset.mediaId;
    if (!id) return;
    const gallery = input.closest('.shopify-section, dialog')?.querySelector('media-gallery');
    // The zoom dialog lists media in slide order with ids like "product-<media id>-<1-based index>".
    const item = gallery?.querySelector(`[id^="product-${id}-"]`);
    const index = Number(item?.id.split('-').pop()) - 1;
    if (index >= 0) gallery?.slideshow?.select(index, undefined, { animate: false });
  };

  /** @param {Element} row @param {string | null} text */
  const setLegend = (row, text) => {
    const value = row.querySelector('.variant-option__swatch-value');
    if (!value) return;
    if (text === null) {
      if (value.dataset.odrSelected !== undefined) value.textContent = value.dataset.odrSelected;
      delete value.dataset.odrSelected;
      return;
    }
    if (value.dataset.odrSelected === undefined) value.dataset.odrSelected = value.textContent ?? '';
    value.textContent = text;
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch' || !(event.target instanceof Element)) return;
    const label = event.target.closest(`${SWATCH_ROW} .variant-option__button-label`);
    const input = label?.querySelector('input[data-media-id]');
    if (!label || !(input instanceof HTMLInputElement)) return;
    showMedia(input);
    setLegend(label.closest(SWATCH_ROW), input.value);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType === 'touch' || !(event.target instanceof Element)) return;
    const row = event.target.closest(SWATCH_ROW);
    if (!row || (event.relatedTarget instanceof Node && row.contains(event.relatedTarget))) return;
    showMedia(row.querySelector('input:checked'));
    setLegend(row, null);
  });

  // A click selects the hovered color, so it becomes the one to return to.
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const value = event.target.closest(SWATCH_ROW)?.querySelector('.variant-option__swatch-value');
    if (value) delete value.dataset.odrSelected;
  });
})();
